import { useEffect } from "react";
import { useNavigate } from "react-router";
import { useArgusConnectionContext } from "../../providers/argus-connection-provider";

/**
 * Invisible bridge component that exposes `useNavigate()` to the Argus
 * connection provider.
 *
 * Rendered inside the Dashboard layout (always inside the router tree),
 * this component reads the router's navigate function on mount and
 * registers it with the provider so the provider's event handler can
 * auto-navigate on `navigate` tool completion when
 * `argusAutoNavigate` is enabled.
 *
 * See `use-argus-connection.ts` for the consumer side.
 */
export const ArgusNavigateBridge = () => {
  const navigate = useNavigate();
  const { registerNavigate } = useArgusConnectionContext();

  useEffect(() => {
    registerNavigate(navigate);
    return () => registerNavigate(null);
  }, [navigate, registerNavigate]);

  return null;
};
